import { useNavigate } from "react-router-dom";
import { getCookie } from "../../App";
import { domain } from "../Links/Links";

let resendSwapRequestCount = 0;
export function SwapRequest(
  sendInputValue,
  receiveInputValue,
  sendType,
  receiveType,
  navigate,
  setSwapRequestStatus,
) {
  fetch(domain + "/swap/", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": getCookie("csrf_token"),
    },
    body: JSON.stringify({
      send_value: sendInputValue,
      receive_value: receiveInputValue,
      send_type: sendType,
      receive_type: receiveType,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      if (data.api_error) {
        if (resendSwapRequestCount < 3) {
          resendSwapRequestCount += 1;
          setTimeout(() => {
            SwapRequest(
              sendInputValue,
              receiveInputValue,
              sendType,
              receiveType,
              navigate,
              setSwapRequestStatus,
            );
          }, 1000);
        } else {
          resendSwapRequestCount = 0;
        }

        return;
      }
      if (data.ok) {
        setSwapRequestStatus(false);
        resendSwapRequestCount = 0;
        navigate("/history");
      }
    });
}
